/**
 * Checkout Backup
 * ======================================
 * Záloha vyplnených údajov v pokladni (fakturačné údaje, IČO, PO, účastníci)
 * v sessionStorage prehliadača. Keď sa údaje nepodarí uložiť na server
 * (napr. chyba „Nonce je neplatný“) a stránka sa obnoví alebo formulár
 * vyprázdni, doplnia sa späť zo zálohy.
 * - záloha platí len v danej záložke a najviac 24 hodín
 * - po dokončení objednávky sa zmaže
 */

const STORAGE_KEY = 'tilma-checkout-backup'
const MAX_AGE = 24 * 60 * 60 * 1000
const CART_STORE = 'wc/store/cart'
const CHECKOUT_STORE = 'wc/store/checkout'

const isEmpty = (value) => value === undefined || value === null || value === '' || value === false

const readBackup = () => {
  try {
    const backup = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY))
    if (backup && Date.now() - backup.time < MAX_AGE) {
      return backup
    }
  } catch (e) {}
  return null
}

const writeBackup = (backup) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...backup, time: Date.now() }))
  } catch (e) {}
}

// Hodnoty zo zálohy pre polia, ktoré sú teraz prázdne
const missingValues = (current, saved) => {
  const values = {}
  Object.keys(saved || {}).forEach((key) => {
    if (isEmpty(current?.[key]) && !isEmpty(saved[key])) {
      values[key] = saved[key]
    }
  })
  return values
}

class CheckoutBackup {
  constructor() {
    if (document.body.classList.contains('woocommerce-order-received')) {
      try { window.sessionStorage.removeItem(STORAGE_KEY) } catch (e) {}
      return
    }

    if (!document.querySelector('.wp-block-woocommerce-checkout')) return

    this.waitForStores()
  }

  waitForStores = (attempt = 0) => {
    const data = window.wp?.data
    if (data?.select(CART_STORE) && data?.select(CHECKOUT_STORE)) {
      this.data = data
      this.restore()
      data.subscribe(this.handleChange)
    } else if (attempt < 100) {
      setTimeout(() => this.waitForStores(attempt + 1), 100)
    }
  }

  getState = () => ({
    billing: this.data.select(CART_STORE).getCustomerData().billingAddress,
    fields: this.data.select(CHECKOUT_STORE).getAdditionalFields(),
  })

  // Doplní prázdne polia zo zálohy, vyplnené hodnoty nemení
  restore = () => {
    const backup = readBackup()
    if (!backup) return

    const { billing, fields } = this.getState()
    const billingValues = missingValues(billing, backup.billing)
    const fieldValues = missingValues(fields, backup.fields)

    this.restoring = true
    if (Object.keys(billingValues).length) {
      this.data.dispatch(CART_STORE).setBillingAddress(billingValues)
    }
    if (Object.keys(fieldValues).length) {
      this.data.dispatch(CHECKOUT_STORE).setAdditionalFields({ ...fields, ...fieldValues })
    }
    this.restoring = false
  }

  handleChange = () => {
    if (this.restoring) return

    const state = this.getState()
    if (state.billing === this.lastBilling && state.fields === this.lastFields) return
    this.lastBilling = state.billing
    this.lastFields = state.fields

    if (this.data.select(CHECKOUT_STORE).isComplete()) {
      try { window.sessionStorage.removeItem(STORAGE_KEY) } catch (e) {}
      return
    }

    const backup = readBackup() || { billing: {}, fields: {} }

    // Naraz zmizlo viac vyplnených polí (prepísali ich prázdne údaje zo servera),
    // používateľ maže polia po jednom – doplníme ich späť
    const wiped = Object.keys(missingValues(state.billing, backup.billing)).length
      + Object.keys(missingValues(state.fields, backup.fields)).length
    if (wiped >= 2) {
      this.restore()
      return
    }

    writeBackup({
      billing: { ...state.billing },
      fields: { ...state.fields },
    })
  }
}

new CheckoutBackup()
